module.exports = __webpack_public_path__ + "assets/images/creatinina_g.71efe2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/creatinina_g.png
// module id = 693
// module chunks = 1